import { FAQAccordion } from '@/components/feature/FAQAccordion';
import type { CommuneData } from '@/data/communes';

export function FAQCommune({ commune }: { commune: CommuneData }) {
  const { nom, slug } = commune;

  const faqItems = [
    {
      question: `Quel est le délai d'intervention à ${nom} ?`,
      answer: `Nous intervenons généralement sous 24 à 48 heures à ${nom}. Pour les urgences (volet bloqué en position ouverte, risque de sécurité), nous faisons notre possible pour intervenir le jour même. N'hésitez pas à nous appeler au 0800 20 410 pour connaître nos disponibilités en temps réel.`,
    },
    {
      question: `Intervenez-vous en urgence à ${nom} ?`,
      answer: `Oui, nous assurons un service de dépannage urgent 7 jours sur 7, y compris le week-end, à ${nom} et dans tout le Hainaut. Si votre volet est bloqué en position ouverte et que vous ne pouvez pas sécuriser votre habitation, contactez-nous immédiatement.`,
    },
    {
      question: `Quelles marques de volets roulants réparez-vous à ${nom} ?`,
      answer: `Nous réparons toutes les marques de volets roulants à ${nom} : Somfy, Simu, Nice, Bubendorff, Profalux, Hörmann, Velux, FAAC, Aprimatic, Selve et bien d'autres. Nous intervenons aussi bien sur les volets manuels (sangle, manivelle) que sur les volets électriques motorisés.`,
    },
    {
      question: `Le diagnostic est-il payant à ${nom} ?`,
      answer: `Le diagnostic est gratuit et sans engagement. Notre technicien se déplace à ${nom}, analyse la panne et vous remet un devis clair avant toute intervention. Vous ne payez que si vous acceptez les travaux.`,
    },
    {
      question: `Puis-je faire motoriser mon volet roulant manuel à ${nom} ?`,
      answer: `Absolument. La motorisation d'un volet manuel est l'une de nos spécialités. Nous installons un moteur tubulaire directement dans le tube d'enroulement de votre volet existant, sans remplacer le tablier ni le coffre. Découvrez tous les détails sur notre page <a href="/motorisation-volet-charleroi/" class="text-accent-500 hover:text-accent-600 underline">motorisation</a>.`,
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="fade-up max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="section-title text-center mb-4">Questions fréquentes à {nom}</h2>
        <p className="section-subtitle text-center mb-10">
          Tout ce que vous devez savoir sur la réparation de volets roulants à {nom}
        </p>
        <FAQAccordion items={faqItems} />
      </div>
    </section>
  );
}